(() => {
  const path = window.location.pathname.toLowerCase();
  const isShipping = path.includes('/policies/shipping-policy');
  const isPrivacy = path.includes('/policies/privacy-policy');
  if (!isShipping && !isPrivacy) return;

  const locale = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  const localizedPrefix = ['es', 'fr'].includes(path.split('/').filter(Boolean)[0])
    ? '/' + path.split('/').filter(Boolean)[0]
    : '';
  const contactUrl = localizedPrefix + '/pages/contact';

  const titleNode = document.querySelector('.shopify-policy__title h1');
  const body = document.querySelector('.shopify-policy__body');

  if (!body) {
    document.documentElement.classList.add('gs-policy-ready');
    return;
  }

  const copy = {
    en: {
      shippingTitle: 'Shipping & Delivery',
      shippingKicker: 'GOALSTYLE SHIPPING',
      shippingLead: 'A clear overview of when your order is prepared, dispatched, and expected to arrive.',
      preparation: 'Order preparation',
      preparationValue: 'Usually 5–8 business days',
      preparationCopy: 'Most orders are prepared and dispatched within this estimated window.',
      arrival: 'Estimated arrival',
      arrivalValue: 'Around 13–15 business days',
      arrivalCopy: 'This estimate is measured from the order date and includes the normal preparation period.',
      tracking: 'Tracking',
      trackingValue: 'Sent after dispatch',
      trackingCopy: 'When tracking is available, we normally email the tracking number and link to the address used at checkout.',
      estimateTitle: 'How the estimate works',
      estimateCopy: 'Delivery times are estimates, not guaranteed dates. Your order may arrive sooner or take a few additional business days depending on destination, customs processing, carrier scans, weather, or peak-volume periods.',
      trackingTitle: 'Tracking your order',
      trackingDetail: 'After dispatch, check the email used at checkout for your shipping confirmation and tracking link. If you do not see it, check Spam, Junk, or Promotions. If you still cannot locate your tracking information, contact GoalStyle and include your order number.',
      helpTitle: 'Need help with an order?',
      helpCopy: 'Our support team can review the latest information available for your shipment.',
      helpButton: 'Contact GoalStyle',
      privacyTitle: 'Privacy Policy',
      privacyIntro: 'This policy explains what personal information GoalStyle processes, why we use it, when it may be shared, and the choices and rights available to you.',
      tocTitle: 'On this page',
      privacyContact: 'For questions about this Privacy Policy or to exercise your privacy rights, contact GoalStyle at <a href="mailto:support@goalstyle.co">support@goalstyle.co</a> or use our <a href="' + contactUrl + '">contact page</a>. Where applicable under data protection law, GoalStyle acts as the data controller of your personal information.'
    },
    es: {
      shippingTitle: 'Envíos y entregas',
      shippingKicker: 'ENVÍOS GOALSTYLE',
      shippingLead: 'Una explicación clara de cuándo preparamos, despachamos y estimamos la llegada de tu pedido.',
      preparation: 'Preparación del pedido',
      preparationValue: 'Normalmente 5–8 días hábiles',
      preparationCopy: 'La mayoría de los pedidos se preparan y despachan dentro de este plazo estimado.',
      arrival: 'Llegada estimada',
      arrivalValue: 'Aproximadamente 13–15 días hábiles',
      arrivalCopy: 'La estimación se calcula desde la fecha de compra e incluye el período normal de preparación.',
      tracking: 'Seguimiento',
      trackingValue: 'Se envía después del despacho',
      trackingCopy: 'Cuando el seguimiento está disponible, normalmente enviamos por email el número y el enlace a la dirección usada en checkout.',
      estimateTitle: 'Cómo funciona la estimación',
      estimateCopy: 'Los tiempos de entrega son estimados, no fechas garantizadas. Tu pedido puede llegar antes o tardar algunos días hábiles adicionales según el destino, aduanas, actualizaciones del transportista, clima o períodos de alta demanda.',
      trackingTitle: 'Seguimiento de tu pedido',
      trackingDetail: 'Después del despacho, revisa el correo utilizado en checkout para encontrar la confirmación de envío y el enlace de seguimiento. Si no aparece, revisa Spam, Correo no deseado o Promociones. Si aún no encuentras el seguimiento, contacta a GoalStyle e incluye tu número de pedido.',
      helpTitle: '¿Necesitas ayuda con un pedido?',
      helpCopy: 'Nuestro equipo de soporte puede revisar la información más reciente disponible sobre tu envío.',
      helpButton: 'Contactar a GoalStyle',
      privacyTitle: 'Política de privacidad',
      privacyIntro: 'Esta política explica qué información personal procesa GoalStyle, por qué la utilizamos, cuándo puede compartirse y qué opciones y derechos tienes disponibles.',
      tocTitle: 'En esta página',
      privacyContact: 'Si tienes preguntas sobre esta Política de privacidad o deseas ejercer tus derechos de privacidad, escribe a GoalStyle a <a href="mailto:support@goalstyle.co">support@goalstyle.co</a> o utiliza nuestra <a href="' + contactUrl + '">página de contacto</a>. Cuando corresponda conforme a la legislación aplicable, GoalStyle actúa como responsable del tratamiento de tu información personal.'
    },
    fr: {
      shippingTitle: 'Expédition et livraison',
      shippingKicker: 'EXPÉDITION GOALSTYLE',
      shippingLead: 'Un aperçu clair du moment où votre commande est préparée, expédiée et devrait arriver.',
      preparation: 'Préparation de la commande',
      preparationValue: 'Généralement 5 à 8 jours ouvrables',
      preparationCopy: 'La plupart des commandes sont préparées et expédiées dans ce délai estimatif.',
      arrival: 'Livraison estimée',
      arrivalValue: 'Environ 13 à 15 jours ouvrables',
      arrivalCopy: 'Cette estimation est calculée à partir de la date de commande et inclut la période normale de préparation.',
      tracking: 'Suivi',
      trackingValue: 'Envoyé après l’expédition',
      trackingCopy: 'Lorsque le suivi est disponible, nous envoyons normalement le numéro et le lien de suivi à l’adresse e-mail utilisée lors du paiement.',
      estimateTitle: 'Comment fonctionne l’estimation',
      estimateCopy: 'Les délais de livraison sont des estimations et non des dates garanties. Votre commande peut arriver plus tôt ou prendre quelques jours ouvrables supplémentaires selon la destination, les douanes, les mises à jour du transporteur, la météo ou les périodes de forte demande.',
      trackingTitle: 'Suivre votre commande',
      trackingDetail: 'Après l’expédition, consultez l’adresse e-mail utilisée lors du paiement pour trouver la confirmation d’expédition et le lien de suivi. Si vous ne la voyez pas, vérifiez les courriers indésirables ou les promotions. Si vous ne trouvez toujours pas le suivi, contactez GoalStyle en indiquant votre numéro de commande.',
      helpTitle: 'Besoin d’aide avec une commande ?',
      helpCopy: 'Notre équipe d’assistance peut vérifier les informations les plus récentes disponibles concernant votre envoi.',
      helpButton: 'Contacter GoalStyle',
      privacyTitle: 'Politique de confidentialité',
      privacyIntro: 'Cette politique explique quelles informations personnelles GoalStyle traite, pourquoi nous les utilisons, quand elles peuvent être partagées et quels choix et droits sont à votre disposition.',
      tocTitle: 'Sur cette page',
      privacyContact: 'Pour toute question concernant cette Politique de confidentialité ou pour exercer vos droits en matière de confidentialité, contactez GoalStyle à <a href="mailto:support@goalstyle.co">support@goalstyle.co</a> ou utilisez notre <a href="' + contactUrl + '">page de contact</a>. Lorsque la législation applicable le prévoit, GoalStyle agit en tant que responsable du traitement de vos informations personnelles.'
    }
  };

  const t = copy[locale] || copy.en;

  if (isShipping) {
    document.body.classList.add('gs-policy-page', 'gs-policy-shipping');
    if (titleNode) titleNode.textContent = t.shippingTitle;

    body.innerHTML = `
      <div class="gs-policy-intro">
        <p class="gs-policy-kicker">${t.shippingKicker}</p>
        <p class="gs-policy-lead">${t.shippingLead}</p>
      </div>

      <div class="gs-shipping-grid">
        <section class="gs-policy-card">
          <span class="gs-policy-card__index">01</span>
          <h2>${t.preparation}</h2>
          <p class="gs-policy-card__value">${t.preparationValue}</p>
          <p class="gs-policy-card__copy">${t.preparationCopy}</p>
        </section>

        <section class="gs-policy-card">
          <span class="gs-policy-card__index">02</span>
          <h2>${t.arrival}</h2>
          <p class="gs-policy-card__value">${t.arrivalValue}</p>
          <p class="gs-policy-card__copy">${t.arrivalCopy}</p>
        </section>

        <section class="gs-policy-card">
          <span class="gs-policy-card__index">03</span>
          <h2>${t.tracking}</h2>
          <p class="gs-policy-card__value">${t.trackingValue}</p>
          <p class="gs-policy-card__copy">${t.trackingCopy}</p>
        </section>
      </div>

      <section class="gs-policy-section">
        <h2>${t.estimateTitle}</h2>
        <p>${t.estimateCopy}</p>
      </section>

      <section class="gs-policy-section">
        <h2>${t.trackingTitle}</h2>
        <p>${t.trackingDetail}</p>
      </section>

      <div class="gs-policy-callout">
        <div>
          <p class="gs-policy-kicker">${t.helpTitle}</p>
          <p>${t.helpCopy}</p>
        </div>
        <a class="gs-policy-button" href="${contactUrl}">${t.helpButton}</a>
      </div>
    `;
  }

  if (isPrivacy) {
    document.body.classList.add('gs-policy-page', 'gs-policy-privacy');
    if (titleNode) titleNode.textContent = t.privacyTitle;

    const overview = document.createElement('div');
    overview.className = 'gs-privacy-overview';
    overview.innerHTML = '<p>' + t.privacyIntro + '</p>';
    body.prepend(overview);

    const headings = [...body.querySelectorAll(':scope > h2')];

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = 'policy-section-' + (index + 1);
    });

    if (headings.length) {
      const toc = document.createElement('nav');
      toc.className = 'gs-policy-toc';
      toc.setAttribute('aria-label', t.tocTitle);
      toc.innerHTML =
        '<p class="gs-policy-toc__title">' + t.tocTitle + '</p>' +
        '<div class="gs-policy-toc__links">' +
        headings
          .map((heading) => '<a href="#' + heading.id + '">' + heading.textContent.trim() + '</a>')
          .join('') +
        '</div>';
      overview.insertAdjacentElement('afterend', toc);
    }

    const paragraphs = [...body.querySelectorAll(':scope > p')];
    const updated = paragraphs.find((p) => {
      const value = p.textContent.trim().toLowerCase();
      return value.startsWith('last updated') ||
        value.startsWith('última actualización') ||
        value.startsWith('dernière mise à jour');
    });
    if (updated) updated.classList.add('gs-policy-last-updated');

    const contactHeading = headings.find((heading) => {
      const value = heading.textContent.trim().toLowerCase();
      return value === 'contact' || value === 'contacto';
    });

    if (contactHeading) {
      const contactParagraph = contactHeading.nextElementSibling;
      if (contactParagraph && contactParagraph.tagName === 'P') {
        contactParagraph.innerHTML = t.privacyContact;
        contactParagraph.classList.add('gs-policy-contact-clean');
      }
    }
  }

  document.documentElement.classList.add('gs-policy-ready');
})();
